
import { defineComponent, PropType, toRefs, computed } from "vue";
import { RouterLink } from "vue-router";
import { StyleTag } from "@/components/common";

import { AlbumModel } from "@/typings";
import { online_link_name } from "@/basics/enums";

export default defineComponent({
    components: {
        StyleTag,
        RouterLink,
    },
    props: {
        album: {
            type: Object as PropType<AlbumModel>,
            required: true,
        },
        showType: {
            type: String,
            default: "",
        },
    },
    setup(props) {
        const { album } = toRefs(props);

        const stylesInShow = computed(() => {
            return album.value.styles.slice(0, 4);
        });

        return {
            stylesInShow,
            online_link_name,
        };
    },
});
